import { render, staticRenderFns } from "./revenueProfit.vue?vue&type=template&id=6e96139f"
import script from "./revenueProfit.vue?vue&type=script&lang=js"
export * from "./revenueProfit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports